var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label"},[_vm._t("default"),_c('span',{staticClass:"dea-rich-text",domProps:{"innerHTML":_vm._s(_vm.text)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }